import axios from "axios";
import { API_BASE_URL } from "./config";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "An unexpected error occurred";

    if (error?.response?.status === 401) {
      const isLoginRoute = error.config?.url?.includes("/auth/login");
      if (!isLoginRoute && typeof window !== "undefined") {
        localStorage.removeItem("loggedInUser");
      }
    }

    return Promise.reject({ ...error, friendlyMessage: message });
  }
);

export default apiClient;
